import {AnimatePresence, motion} from "framer-motion";
import React from "react";
import ExtraCostsState from "./interface/ExtraCostsState";
import ExtraCostsController from "./controller/ExtraCostsController";
import AppSettingController from "../../../Main/controller/AppSettingController";
import marketSettingLocalStorage from "../../../Main/interface/MarketSettingLocalStorage";
import {useTranslation} from "react-i18next";

export default function ExtraCostsForm({state, setState}: {
    state: ExtraCostsState,
    setState: React.Dispatch<React.SetStateAction<ExtraCostsState>>
}) {
    const {t, i18n} = useTranslation();
    const lang = i18n.language === 'ar-IQ' ? 'ar-IQ' : 'fa-IR';
    const controller = new ExtraCostsController(state, setState)
    const setting = AppSettingController.getSetting() as marketSettingLocalStorage;
    const currency = setting.currency || t("currency.default");
    return (
        <AnimatePresence>
            <motion.section
                className="public-key-container"
                initial={{scaleY: 0, opacity: 0}}
                animate={{scaleY: 1, opacity: 1}}
                exit={{scaleY: 0, opacity: 0}}
                transition={{duration: 0.3, ease: "easeInOut"}}
                style={{originY: 0}}
            >
                <form className="add-discount-form"
                      onSubmit={e => controller.addExtraCosts(e)}>
                    <h3>{state.isActiveEdit ? t("setting.editExtraCosts") : t("setting.addExtraCosts")}</h3>
                    <div className="inputs-container">
                        <label>
                            <input type="text"
                                   placeholder={t("setting.extraCostsName")}
                                   value={state.extraCostsName}
                                   onChange={e => controller.setExtraCostsName(e)}/>
                        </label>
                        <select onChange={e => controller.changeType(e)} value={state.type}>
                            <option value="percentage">{t("percentage")}</option>
                            <option value="price">{t("price")}</option>
                        </select>
                        <label className={'price-discount'}>
                            {state.type === "percentage" ?
                                <input type="text" value={state.extraCostsPercentage}
                                       placeholder={t("setting.extraCostsPercentage")}
                                       inputMode={'numeric'}
                                       onChange={e => new ExtraCostsController(state, setState).setDiscount(e)}/> :
                                <input type="text" value={state.extraCostsPrice}
                                       placeholder={t("setting.extraCostsPrice")}
                                       inputMode={'numeric'}
                                       onChange={e => new ExtraCostsController(state, setState).setDiscount(e)}/>
                            }
                            {state.type === "price" ?
                                <p>{Number(state.extraCostsPrice).toLocaleString(lang)}{currency}</p> : null}
                        </label>
                        <select onChange={e => controller.changeState(e)} value={state.state}>
                            <option value="active">{t("enable")}</option>
                            <option value="deactivate">{t("disable")}</option>
                        </select>
                        <button type="submit"
                                onClick={e => controller.addExtraCosts(e)}>
                            {state.isActiveEdit ? t("edit") : t("add")}
                        </button>
                    </div>
                    {state.error ? <p className={'error'}>{state.message}</p> : null}
                </form>
            </motion.section>
        </AnimatePresence>
    );
}